import React, { useEffect, useState } from 'react'
import MediaInput from '@/features/generation/MediaInput'
import { Tabs } from '@/shared/components/AppTabs'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { CardWrapper, MainCardWrapper } from '@/shared/components/CardWrapper'
import { upperCase } from '@/shared/lib/appHelpers'
import { selectUserData } from '@/api/rtk/userSelectors'
import { useCurrentTool } from '@/shared/hooks/useCurrentTool'
import { useTranslation } from 'react-i18next';
import { useGetReportTemplatesQuery } from '@/api/rtk/reportsApi'

function AddReport({ activeDraft, setActiveDraft }) {
  const [hidingTabs, setHidingtabs] = useState(false);
  const userId = localStorage.getItem('user_id')
  const navigate = useNavigate()
  const { t } = useTranslation();

  const userData = useSelector(selectUserData);
  const { generation_name, toolId, toolInputs, nonAudioTool } = useCurrentTool();

  const { isFetching: templatesLoading } = useGetReportTemplatesQuery({ toolId }, { skip: !toolId });

  let isDisabled = { loading: true, noWords: true };
  isDisabled.loading = !userData || templatesLoading;
  isDisabled.noWords = !userData?.tokens;

  const inputs = toolInputs.map((input, index) => {
    const name = input.type.split('_').reverse().join(' ');
    return {
      name: upperCase(name),
      active: index === 0,
      value: input.type
    }
  })

  const [tabs, setTabs] = useState(inputs)
  const [selectedTab, setSelectedTab] = useState(inputs[0].value)

  useEffect(() => {
    if (activeDraft) {
      setSelectedTab('audio_record');
      setHidingtabs(true);
    }
  }, [activeDraft]);

  const handleTabChange = async (tabType) => {
    let updatedTabs = []

    tabs?.forEach((tab) => {
      if (tab.name === tabType) {
        setSelectedTab(tab.value)
        updatedTabs.push({
          name: tab.name,
          active: true,
          value: tab.value
        })
      }
      else {
        updatedTabs.push({
          name: tab.name,
          active: false,
          value: tab.value
        })
      }
    })
    setTabs(updatedTabs)

  };

  useEffect(() => {
    if (!userId) {
      navigate('/')
    }
  }, [userId, navigate])

  const getToolInputs = () => {
    return (
      toolInputs?.map((input) => {
        if (input.type === 'audio_record') {
          return (
            <div className={` ${selectedTab === input.type ? '' : 'hidden'}`} key={input.type}>
              <CardWrapper className='border-none p-0'>
                <MediaInput mode="record" toolId={toolId} setHidingtabs={setHidingtabs} isDisabled={isDisabled} activeDraft={activeDraft} setActiveDraft={setActiveDraft} />
              </CardWrapper>
            </div>
          )
        }
        if (input.type === 'audio_upload' || input.type === 'document_upload') {
          return (
            <div className={` ${selectedTab === input.type ? '' : 'hidden'}`} key={input.type}>
              <MediaInput mode="upload" toolId={toolId} setHidingtabs={setHidingtabs} isDisabled={isDisabled} />
            </div>
          )
        }
        return null;
      })
    )
  }

  const subtitle = nonAudioTool ? t('reports.add.subtitleNonAudio', { type: generation_name }) : t('reports.add.subtitle', { type: generation_name });

  return (
    <MainCardWrapper addingReport>
      <div className='text-center '>
        <div className="flex justify-between flex-wrap items-center">
          <div className={`${hidingTabs ? 'hidden' : 'hidden md:flex'}`}>
            <div className="text-left">
              <h1 className="font-medium text-[20px]">{t('reports.add.title', { type: generation_name })}</h1>
              <p className="text-[#505050] font-SuisseIntlLight font-normal mt-[4px] text-[14px]">{subtitle}</p>
            </div>
          </div>

        </div>
        <div className={` flex-col ${hidingTabs ? 'hidden' : 'flex md:hidden'}`}>
          <h1 className="font-semibold font-SuisseIntlLight text-left text-[16px] mt-[10px]">{t('reports.add.mobileTitle', { type: generation_name })}</h1>
          <p className="text-[#505050] font-SuisseIntlLight text-left font-normal mt-[4px] text-[14px]">{subtitle}</p>
        </div>

        <div className={`${tabs.length > 1 ? 'my-6' : 'mb-6'} ${hidingTabs ? 'hidden' : 'block'}`}>
          {tabs.length > 1 && <Tabs tabs={tabs} onChange={handleTabChange} />}
        </div>
        {getToolInputs()}
      </div>
    </MainCardWrapper>
  )
}

export default AddReport